import React from 'react';
import axios from 'axios';
import { Card, Alert, Row, Col } from 'antd';

import apiPath from 'apiPath';
import passport from 'components/passportUtils';

export default class VisaInformation extends React.Component {
	state = { oldfolio: {} }
	componentWillMount() {
		// get passport details from resco
		axios.get(apiPath + '/oldfolio', { withCredentials: true }).then(result => {
			this.setState({ oldfolio: result.data });
		}).catch(this.props.handleAxiosLoadError);
	}

	render() {
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'travel/visadocs');
			if (redirect) return redirect;
		}

		const props = this.props;
		if ((props.remarksLoaded && !props.remarks.find(remark => remark.Code === 'VISAPRE' && remark.rmkNumericCheck1 === '1')) || !passport.isComplete(passport.parseFromFolio(props.folio))) {
			return <Alert showIcon type="error" message="Previous section required" description="Please fill out your passport details and agree to the pre-embarkation terms" />;
		}

		const passengerPassport = passport.parseFromFolio(this.state.oldfolio);
		const colLayout = {
			xs: 24, md: 12, lg: 8, style: { padding: '4pt' }
		};
		return (
			<div className="withSpacing">
				<p>
					Visa information is based upon the passport details you uploaded on your MyPassport page (see Personal Details Edit box).
					Please verify that your passport information is correct.
					It is also your responsibility to verify the provided visa information is correct.
				</p>
				<Alert
					showIcon
					type="warning"
					message="Important:"
					description="Visa regulations are subject to change and ISE cannot be held responsible for incurred fees, fines, detainment or deportation due to missing visas." />
				<Row>
					<Col {...colLayout}>
						<Card title="Instructions">
							{this.props.booking.EventId !== '40' &&
								<form encType="multipart/form-data" action="http://tours.travisa.com/sas" method="POST" target="_blank">
									<a><input type="submit" value="Visa Instructions" style={{ border: 'none', background: 'none', cursor: 'pointer' }} /></a>
								</form>
							}
							{this.props.booking.EventId === '40' && (this.props.isLLL)  &&
								<a target="blank" href="https://visas.travisa.com/tourkits?bookmark=1&login=saslifelonglearners">
									Visa Instructions
								</a>
							}
							{this.props.booking.EventId === '40' && (!this.props.isLLL) &&
								<a target="blank" href="https://visas.travisa.com/tourkits?bookmark=1&login=semesteratsea">
									Visa Instructions
								</a>
							}
						</Card>
					</Col>
					<Col {...colLayout}>
						<Card title="Visas 101">
							{this.props.booking.EventId === '38' &&
								<a target="blank" href="https://youtu.be/zYtB9RA5wck">
									Step-by-Step Visa Acquisition Video Tutorial
								</a>
							}
							{this.props.booking.EventId === '40' &&
								<a target="blank" href="https://www.youtube.com/watch?v=X8dq1XVaTBw">
									Step-by-Step Visa Acquisition Video Tutorial
								</a>
							}
						</Card>
					</Col>
					<Col {...colLayout}>
						<Card title="Voyage Itinerary">
							<form target="_blank" encType="multipart/form-data" action="/passageticket/" method="POST">
								<input type="hidden" name="RepeaterNo" value={this.props.folio.RepeaterNo} />
								<input type="hidden" name="EventId" value={this.props.booking.EventId} />
								<a><input type="submit" value="Download Voyage Itinerary (pdf)" style={{ border: 'none', background: 'none', cursor: 'pointer' }} /></a>
							</form>
						</Card>
					</Col>
					<Col {...colLayout}>
						<Card title="Printable Visa Invitation Letters">
							<form target="_blank" encType="multipart/form-data" action={this.props.booking.EventId == '38' ? (apiPath + '/visafall') : (apiPath + '/visaspring')} method="POST">
								<input type="hidden" name="location" value="all" />
								<input type="hidden" name="first_name" value={this.props.folio.Forename + ' ' + this.props.folio.Midname} />
								<input type="hidden" name="last_name" value={this.props.folio.Surname} />
								<input type="hidden" name="passport_number" value={passengerPassport.No} />
								This links generates all visa letters - only use the visa letters required by your nationality.
								If you are unsure which visas you need, please contact <a href="mailto:programadministration@isevoyages.org">programadministration@isevoyages.org</a>.
								<a><input type="submit" value="Download Printable Visa Invitation Letters (pdf)" style={{ border: 'none', background: 'none', cursor: 'pointer' }} /></a>
							</form>
						</Card>
					</Col>
					{this.props.booking.EventId === '38' &&
						<div>
							<Col {...colLayout}>
								<Card title="Passport Requirements 101">
									<a target="blank" href="https://www.semesteratsea.org/info-hub/fall-2019-voyage-prep/#fa19-passport-requirements">
										Passport Information and Requirements
							</a>
								</Card>
							</Col>
							<Col {...colLayout}>
								<Card title="Visa Checklist">
									<a target="blank" href="http://www.semesteratsea.org/wp-content/uploads/2019/04/FA19-Visa-Checkist-updated.pdf">
										Visa Checklist
						</a>
								</Card>
							</Col>
						</div>
					}
					{this.props.booking.EventId === '40' &&
						<div>
							<Col {...colLayout}>
								<Card title="Passport Requirements 101">
									<a target="blank" href="https://www.semesteratsea.org/info-hub/spring-2020-voyage-prep/#sp20-passport-requirements">
										Passport Information and Requirements
							</a>
								</Card>
							</Col>
							<Col {...colLayout}>
								<Card title="Visa Checklist">
									<a target="blank" href="https://cdn2.hubspot.net/hubfs/4396045/SP20%20Visa%20Checklist.pdf">
										Visa Checklist
						</a>
								</Card>
							</Col>
						</div>
					}
				</Row>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Travel/VisaInstructions.jsx